<template>
  <div
    class="modal fade"
    id="changePasswordModal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="changePasswordModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header shadow-sm">
          <h6
            class="modal-title font-weight-bold"
            id="changePasswordModalLabel"
          >
            <!-- <font-awesome-icon :icon="['fas', 'key']" class="media-icon mr-2" /> -->
            <!-- Change Password -->
          </h6>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="closeModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="case-body">
            <div class="case-list no-pointer border-bottom" v-if="post">
              <div
                :class="
                  post.type !== 'whatsapp' && 'd-flex justify-content-between'
                "
              >
                <div
                  class="media"
                  :style="
                    post.type !== 'whatsapp' &&
                    'width: 60%; work-break: break-word;'
                  "
                >
                  <div class="media">
                    <img
                      :src="post.socmedAvatarUrl"
                      class="mr-3 media-image"
                      v-if="post.socmedAvatarUrl"
                      @error="onImageError(cl, $event)"
                    />
                    <img
                      src="@/assets/pothole.jpg"
                      class="mr-2 media-image"
                      v-else-if="post.type == 'waze'"
                    />
                    <img
                      src="@/assets/user.jpg"
                      class="mr-2 media-image"
                      v-else
                    />
                    <div class="media-body">
                      <p class="media-title mb-0">
                        {{ post.socmedUsername }}
                      </p>
                      <div>
                        <p
                          class="text-muted small mb-2 d-inline-block"
                          :title="getMoment('title', post.timestamp)"
                        >
                          {{ getMoment("display", post.timestamp) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="mt-3">
                <text-highlighter :type="post.type" :text="post.caption" />
              </p>
            </div>
            <div class="my-3 px-3">
              <textarea
                class="w-100 reply"
                autofocus
                v-model="replyModel"
                rows="3"
                style="resize: none; border: none"
                placeholder="Reply here"
                required
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer shadow">
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="closeModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-sm btn-custom"
            @click="saveChanges()"
            :disabled="!replyModel"
          >
            <div
              class="spinner-border spinner-border-sm text-light"
              v-if="isProcessing"
            ></div>
            <span v-else> Reply </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import Moment from "moment";
import Swal from "sweetalert2";
import TextHighlighter from "@/components/TextHighlighter";

export default {
  name: "social-reply-modal",
  props: ["show", "post"],
  components: {
    "text-highlighter": TextHighlighter,
  },
  data() {
    return {
      isProcessing: false,
      replyModel: null,
      models: {
        currentPassword: null,
        newPassword: null,
      },
      emptyModels: {
        currentPassword: null,
        newPassword: null,
      },
    };
  },
  watch: {
    show: {
      async handler() {
        if (this.show) {
          $("#changePasswordModal").modal("show");
          this.replyModel = null;
        } else {
          $("#changePasswordModal").modal("hide");
        }
      },
      immediate: true,
    },
  },
  methods: {
    getMoment(type, d) {
      if (!d) {
        return "-";
      } else {
        switch (type) {
          case "title":
            return Moment(d).format("DD MMMM YYYY, hh:mm A");
          case "display":
            return Moment(d).fromNow(false);
          default:
            return "";
        }
      }
    },
    closeModal() {
      if (!this.isProcessing) {
        this.$emit("close");
      }
    },
    onImageError(cl, event) {
      let image = event.target;

      image.onerror = null;

      image.src = require("@/assets/user.jpg");
    },
    saveChanges() {
      if (this.replyModel) {
        const tweetId = this.post.socmedPostUrl.split("/").pop();

        this.closeModal();
        window.open(
          `https://twitter.com/intent/tweet?text=${this.replyModel}&in_reply_to=${tweetId}`
        );
      }
    },
  },
};
</script>